// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__KAuPs","rightAdornment":"Header_rightAdornment__3fu0D"};